module.exports = "<div class=\"error-text mb10 mt10\">{{validationSummary}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/guest-user/guest-user.component.html
// module id = ./src/app/manage-users/guest-user/guest-user.component.html
// module chunks = main